import Backbone from "backbone";
import Basket from "../common/models/Basket";
import $ from "jquery";
import SharedDispatcher from "../common/others/SharedDispatcher";
import Cookies from "js-cookie";

export default Backbone.View.extend({

  initialize: function () {
    this.increaseDecrease = this.increaseDecrease.bind(this);
    this.updateQuantity = this.updateQuantity.bind(this);
    this.renderCartCounter = this.renderCartCounter.bind(this);

    this.model = new Basket();
    this.renderCartCounter();
  },

  events: {
    "click .js-ProductBuy-changeQuantityBtn": "increaseDecrease",
    "blur .js-ProductBuy-changeQuantityInput": "increaseDecrease" // FIXME use change event instead, support use absolute value change instead of relative ("diff")
  },

  // Quantity for FnacPro
  increaseDecrease: function (event) {

    // Set the new quantity from nasket modal
    const $basketModal = $(".js-basketModal");
    if ($basketModal.length) {
      if (event.currentTarget.classList.contains("js-ProductBuy-increase")) {
        if ($basketModal.find(".js-ProductBuy-changeQuantityInput").val() !== "999") {
          this.updateQuantity(1, $basketModal);
        }
      } else if (event.currentTarget.classList.contains("js-ProductBuy-decrease")) {
        if ($basketModal.find(".js-ProductBuy-changeQuantityInput").val() !== "1") {
          this.updateQuantity(-1, $basketModal);
        }
      } else {
        let $newValue = parseInt(event.currentTarget.value);
        let $oldValue = parseInt(event.currentTarget.getAttribute('data-value'));
        let $quantityDifference = $newValue - $oldValue;
        event.currentTarget.setAttribute('data-value', $newValue);

        this.updateQuantity($quantityDifference, $basketModal);
      }
      return;
    }

    // Update quantity field value when clicking on increase/decrease buttons
    let inputQuantity;
    if (event.currentTarget.classList.contains("js-ProductBuy-changeQuantityInput")) {
      inputQuantity = $(event.currentTarget);
    } else {
      inputQuantity = this.$el.find(".js-ProductBuy-changeQuantityInput");
    }

    let quantityBox = inputQuantity.val();
    if (event.currentTarget.classList.contains("js-ProductBuy-decrease")) {
      if (quantityBox > 1) {
        quantityBox--;
      }
    } else if (event.currentTarget.classList.contains("js-ProductBuy-increase")) {
      if (quantityBox < 999) {
        quantityBox++;
      }
    }
    $(event.currentTarget).val(quantityBox);
    inputQuantity.val(quantityBox);

    // Update quantity on "Add to basket" button 
    const $thumbnailQty  = $(event.target).parents(".thumbnail-quantityContainer");
    const $basketQty     = $(event.target).parents(".addBasketQuantity-container");

    if ($thumbnailQty.length > 0) {
      $thumbnailQty.siblings(".js-ProductBuy-add").attr("data-quantity", quantityBox);
    } else if ($basketQty.siblings(".js-ProductBuy-add").length > 0) {
      $basketQty.siblings(".js-ProductBuy-add").attr("data-quantity", quantityBox);
    } else if ($basketQty.siblings(".js-ProductBuy").length > 0) {
      $basketQty.siblings(".js-ProductBuy").attr("data-quantity", quantityBox);
      $basketQty.siblings(".js-ProductBuy").children().attr("data-quantity", quantityBox);
    }

  },
  updateQuantity: function (quantityDifference, $basketModal) {
    // Update product quantity from basket modal
    const $item = $basketModal.find(".js-basketModalProduct");

    const productId = $item.data("productid");
    const offerId = $item.data("offer-id");
    const masterProductId = $item.data("master-product-id");

    if (quantityDifference === 1 || quantityDifference === -1) {
      var itemNewQuantity = parseInt($basketModal.find(".js-ProductBuy-changeQuantityInput").val()) + quantityDifference;
      $basketModal.find(".js-ProductBuy-changeQuantityInput").val(itemNewQuantity);
    }

    // If the new quantity is lower than 1, let"s delete this item
    if (itemNewQuantity <= 0) {
      return;
    }

    // If we reached the maximum quantity allowed for this item
    if (itemNewQuantity > $item.data("quantityMax")) {
      return;
    }

    // Cart update
    this.model.set({
      productId: productId,
      offerId: offerId,
      masterProductId: masterProductId,
      quantityDifference: quantityDifference
    });

    this.model.fetch({
      action: "update",
      dataType: "html"
    });
  },
  renderCartCounter: function () {
    // We update the basket items counter
    var count = Cookies.get('NBART');
    if (count) {
      SharedDispatcher.trigger("cartcount:update", {
        count: count
      });
    }
  }
});
